import React from 'react';
import { ThemeToggle } from './index';
import './Header.css';

/**
 * Header Component
 * Main navigation header with logo, nav tabs, and theme toggle
 * 
 * @param {Object} props
 * @param {string} props.currentView - Current active view ('media' | 'dashboard')
 * @param {Function} props.onNavigate - Navigation callback (view) => void
 */
function Header({ currentView, onNavigate }) {
  const navItems = [
    { id: 'media', label: 'YouTube Videos', icon: '📺' },
    { id: 'dashboard', label: 'Trending Tags', icon: '🏷️' },
  ];

  return (
    <header className="app-header">
      <div className="header-container">
        {/* Logo / Brand */}
        <div className="header-brand" onClick={() => onNavigate('media')}>
          <span className="brand-icon">🔥</span>
          <span className="brand-name">TrendPulse</span>
        </div>

        {/* Navigation Tabs */}
        <nav className="header-nav">
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`nav-tab ${currentView === item.id || 
                (item.id === 'media' && currentView === 'media-detail') ? 'active' : ''}`}
              onClick={() => onNavigate(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </nav>

        {/* Right side - Theme Toggle */}
        <div className="header-actions">
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}

export default Header;
